module.exports = __webpack_public_path__ + "img/nagasaki.5b3a29c2.jpg";